import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authMe, authLogin, authLogout } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    // null = checking; true = authed; false = not authed
    const [authed, setAuthed] = useState(null);

    const refresh = useCallback(async () => {
        try {
            const r = await authMe();
            setAuthed(!!r.authenticated);
        } catch {
            setAuthed(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = useCallback(async (password) => {
        const r = await authLogin(password);
        setAuthed(!!r.authenticated);
        return r;
    }, []);

    const logout = useCallback(async () => {
        try {
            await authLogout();
        } finally {
            setAuthed(false);
        }
    }, []);

    return (
        <AuthCtx.Provider value={{ authed, login, logout, refresh }}>
            {children}
        </AuthCtx.Provider>
    );
}

export function useAuth() {
    const v = useContext(AuthCtx);
    if (!v) throw new Error("useAuth must be used inside AuthProvider");
    return v;
}
